import { COMMON_CONSTS } from '../common/common.consts'

export const CONTEXT_CONSTS = {
  moduleName: 'epb-context',

  getters: {
    context: 'context',
    baseContext: 'baseContext',
    enabledFilters: 'enabledFilters',
    appliedFiltersCount: 'appliedFiltersCount',
    filtersAreValid: 'filtersAreValid',
  },
  actions: {
    ...COMMON_CONSTS.actions,
    setContext: 'setContext',
    setFiltersSelectedValues: 'setFiltersSelectedValues',
    clearFilters: 'clearFilters',
    setQuery: 'setQuery',
    setStrictMatching: 'setStrictMatching',
    setEndpointId: 'setEndpointId',
  },
  mutations: {
    ...COMMON_CONSTS.mutations,
    setContext: 'setContext',
  },
}
